<template>
    <div>
        <draggable class="row text-left draggable" :list="tickets" @change="sort($event)">
            <div v-for="(props,index) in tickets" :key="index" class="draggable-row columns bordered m-r-none m-l-none">
                <div class="is-narrow column"><b-icon icon="menu" class="cursor-grabbing"></b-icon></div>
                <div class="is-narrow column">{{props.id | makeIDSixDigits}}</div>
                <div class="is-narrow column is-2">
                    <div class="field has-addons">
                        <p class="control">
                            <b-tooltip :label="props.attributes.created_by.email"
                                type="is-dark" position="is-right">
                                <button class="button is-small is-warning">
                                    <span>{{getAbbreviation(props.attributes.created_by ? props.attributes.created_by.email : 'N/A')}}</span>
                                </button>
                            </b-tooltip>
                        </p>
                        <p class="control">

                            <b-tooltip :label="props.attributes.app ? props.attributes.app.name : 'N/A'" position="is-right"
                                type="is-dark">
                                <button class="button is-info is-small">
                                    <span>{{getAbbreviation(props.attributes.app ? props.attributes.app.name : 'N/A')}}</span>
                                </button>
                            </b-tooltip>
                        </p>
                        <p class="control">
                            <b-tooltip type="is-dark" :label="props.attributes.type.toUpperCase()" position="is-right">

                                <button class="button is-small">
                                    <span class="icon ">
                                    <i :class="'mdi '+getIcon(props.attributes.type)+' mdi-18px'"></i></span>
                                </button>
                            </b-tooltip>
                        </p>
                        <p class="control" v-if="props.attributes.rank">
                            <button class="button is-primary is-small" v-if="hover!=props.id" @mouseover="hoverTicket(props.id)">
                                {{props.attributes.rank}}
                            </button>
                            <b-button 
                                class="button is-small"
                                type="is-primary" 
                                size="is-small" 
                                icon-left="cancel" 
                                v-else 
                                @mouseout="hoverTicket(null)"
                                @click="setRankNull(props,index)">
                            </b-button>
                        </p>
                    </div>
                </div>
                <div class="is-narrow column is-1">
                    <div class="d-flex align-items-center">
                        {{ props.attributes.priority }}
                        <span
                            class="icon has-text-danger"
                            v-if=" props.attributes.is_escalated == 1 "
                        >
                            <i class="mdi mdi-alert-decagram mdi-18px"></i>
                        </span>
                    </div>
                </div>
                <div class="is-narrow column">
                    {{props.attributes.status}}
                </div>
                <div class="column ellipsis" :title="props.attributes.details">
                    {{props.attributes.details}}
                </div>
            </div>
        </draggable>
        <b-loading :active="isLoading" :is-full-page="false"></b-loading>
    </div>
</template>

<script>
/* eslint-disable */
import draggable from 'vuedraggable';
import Vue from "vue";
import _ from 'lodash';

export default {
    props:{
        data:{
            Array
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    components:{
        draggable
    },
    data() {
        return {
            tickets:[],
            oldTickets:[],
            hover:null,
        }
    },
    watch:{
        data(value){
            this.tickets = value
        }
    },
    methods:{
        async sort(event){
            var ranked = await this.tickets.filter((element,key)=>{
                return element.attributes.rank || key == event.moved.newIndex
            }).map((element,key)=>{
                element.attributes.rank = key+1
                return element
            })
            var ids = ranked.map((element)=>element.id)
            Vue.$ticketService.sort({ids}).then((response)=>{
                // this.tickets.splice(0,ranked.length,...ranked)
                this.$emit('resetTickets');
                this.$buefy.toast.open({
                    type: 'is-success',
                    message:'Tickets sorted',
                });
            })
        },
        updateTicket(payload,id){
            return Vue.$ticketService.updateTicket(id,payload)
        },
        showCancel(){
            this.$refs.cancelDropdown.click()
        },
        setRankNull(ticket,index){
            let payload = {
                rank:0,
                type: ticket.attributes.type,
                priority: ticket.attributes.priority,
                details: ticket.attributes.details,
                app_id: ticket.attributes.app_id
            }

            this.updateTicket(payload,ticket.id).then((response)=>{
                this.$emit('resetTickets');
                this.$buefy.toast.open({
                    type: 'is-success',
                    message:'Ticket rank removed',
                });
            })
        },
        hoverTicket(id = null){
            this.hover = id
        }
    },
    mounted(){
        this.tickets = this.data
    }
}
</script>